import React, { memo } from "react";
import { Checkbox } from "./checkbox";
import EllipsisTooltip from "@component/tooltip/EllipsisTooltip";
import { cn } from "@/lib/utils";

const ExportList = ({ list = [], onClick = () => null, loading = false , containerRef }) => {
  return (
    <div className="grid grid-cols-2 max-h-32 overflow-y-auto bg-gray-200/50 dark:bg-gray-700/65 border border-card-border rounded-md py-1 px-2">
      {list.map((item, i) => (
        <div key={i}>
          <div
            className={cn(
              "items-center gap-2 cursor-pointer m-1 flex select-none",
              loading && "opacity-50 cursor-not-allowed pointer-events-none"
            )}
            onClick={() => onClick(item, i)}
          >
            <Checkbox
              checked={item?.checked}
              className={cn('mt-1',item?.checked && "border-primary")}
              onChange={() => onClick(item, i)}
            />
            <EllipsisTooltip containerRef={containerRef}>
              <span className="text-sm">{item?.displayName}</span>
            </EllipsisTooltip>
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(ExportList);
